var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home"},[_c('HomeHero'),_c('HomeIntro'),_c('HomeGallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }